import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with credentials
const apiClient = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Format API error details
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Si è verificato un errore. Riprova.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

// Auth API
export const authAPI = {
  login: async (email, password) => {
    const { data } = await apiClient.post('/auth/login', { email, password });
    return data;
  },
  logout: async () => {
    const { data } = await apiClient.post('/auth/logout');
    return data;
  },
  getMe: async () => {
    const { data } = await apiClient.get('/auth/me');
    return data;
  },
};

// Profiles API
export const profilesAPI = {
  getAll: async (filters = {}) => {
    const { data } = await apiClient.get('/profiles', { params: filters });
    return data;
  },
  create: async (profileData) => {
    const { data } = await apiClient.post('/profiles', profileData);
    return data;
  },
  update: async (id, profileData) => {
    const { data } = await apiClient.put(`/profiles/${id}`, profileData);
    return data;
  },
  delete: async (id) => {
    const { data } = await apiClient.delete(`/profiles/${id}`);
    return data;
  },
};

// Contacts API
export const contactsAPI = {
  create: async (contactData) => {
    const { data } = await apiClient.post('/contacts', contactData);
    return data;
  },
  getAll: async () => {
    const { data } = await apiClient.get('/contacts');
    return data;
  },
};

export default apiClient;
